import React from "react";
import { useSelector } from "react-redux";
import Spinner from "../../../components/presentationals/Spinner";
import Error from "../../../components/Error/index";
import RechargeSalesOthersCustomizedTables from "../../../components/table/rechageSalesOthersCustomizedTable";

const OthersTop5RetailersView = ({ partnerRT }) => {
  const { getTopFiveRetailer } = useSelector(
    (state) => state.rechargeSalesReducer
  );
  let top5RetailersData = getTopFiveRetailer.data;

  const emptyObject = {
    0: { id: "", name: "", rechargeAmount: "" },
  };

  return (
    <>
      {partnerRT === "DT" ? (
        <>
          <RechargeSalesOthersCustomizedTables data={emptyObject} />
        </>
      ) : (
        <>
          {getTopFiveRetailer.loading ? (
            <Spinner />
          ) : Object.keys(top5RetailersData).length ? (
            <RechargeSalesOthersCustomizedTables data={top5RetailersData} />
          ) : (
            <Error error={getTopFiveRetailer.error} />
          )}
        </>
      )}
    </>
  );
};

export default OthersTop5RetailersView;
